// import { useLocation } from "react-router-dom";
// import {
//   BreadCrumb,
//   Banner,
//   HeadingTitle,
//   Button,
//   SubHeadingTitle,
//   Input,
// } from "../../../components/shared/index";
// import styles from "./contact.module.css";
// import { FaEnvelope, FaPhoneAlt, FaAddressBook } from "react-icons/fa";
// import toast from "react-hot-toast";
// import { useContactUsMutation } from "../../../queries/useContactUs";
// import { useForm } from "react-hook-form";
// import BackToTop from "../../../components/BackToTop/backtotop";
// const Contact = () => {
//   const { pathname } = useLocation();
//   const parts = pathname.split("/");
//   const newPath = parts[parts.length - 2];
//   const {
//     register,
//     handleSubmit,
//     reset,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {
//       name: "",
//       email: "",
//       subject: "",
//       message: "",
//     },
//   });
//   const { mutateAsync: contactSend, isPending } = useContactUsMutation();
//   const handleMessageSend = async (data) => {
//     try {
//       const response = await contactSend(data);
//       toast.success(response?.data?.message || "Message sent successfully");
//       reset();
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message || "Oops! Message send failed"
//       );
//     }
//   };
//   return (
//     <section className={styles.contact__wrapper}>
//       <BreadcrumbBanner
//         newPath={newPath}
//         heading="We’re here to help with your fashion questions, orders, and support"
//         imageUrl="/contact.png"
//       />
//       <MapLocation />
//       <div className={styles.contactDetails__wrapper}>
//         <div className={styles.contact__form}>
//           <HeadingTitle
//             text="Tell Us Your Message"
//             style={styles.contact__title}
//           />
//           <form onSubmit={handleSubmit(handleMessageSend)}>
//             <div className={styles.form__group}>
//               <label>
//                 Your Name <span>*</span>
//               </label>
//              <input
//   type="text"
//   placeholder="Enter your name"
//   {...register("name", {
//     required: "Name is required",
//     pattern: {
//       value: /^[A-Za-z\s]+$/,
//       message: "Only alphabets are allowed",
//     },
//     minLength: {
//       value: 3,
//       message: "Name must be at least 3 characters",
//     },
//     maxLength: {
//       value: 30,
//       message: "Name cannot exceed 30 characters",
//     },
//   })}
// />
//               {errors?.name && (
//                 <p className={styles.error}>{errors.name.message}</p>
//               )}
//             </div>
//             <div className={styles.form__group}>
//               <label>
//                 Your Email <span>*</span>
//               </label>
//             <input
//   type="email"
//   placeholder="Enter your email"
//   {...register("email", {
//     required: "Email is required",
//     pattern: {
//       value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
//       message: "Enter a valid email address",
//     },
//   })}
// />
//               {errors?.email && (
//                 <p className={styles.error}>{errors.email.message}</p>
//               )}
//             </div>
//             <div className={styles.form__group}>
//               <label>Subject</label>
//              <input
//   type="text"
//   placeholder="Enter subject"
//   {...register("subject", {
//     required: "Subject is required",
//     pattern: {
//       value: /^[A-Za-z0-9\s.,!?'-]+$/,
//       message: "Invalid subject format",
//     },
//     minLength: {
//       value: 3,
//       message: "Subject must be at least 3 characters",
//     },
//     maxLength: {
//       value: 100,
//       message: "Subject cannot exceed 100 characters",
//     },
//   })}
// />
//             </div>
//             <div className={styles.form__group}>
//               <label>
//                 Your Message <span>*</span>
//               </label>
//             <textarea
//   rows="5"
//   placeholder="Type your message"
//   {...register("message", {
//     required: "Message is required",
//     minLength: {
//       value: 10,
//       message: "Message must be at least 10 characters",
//     },
//     maxLength: {
//       value: 500,
//       message: "Message cannot exceed 500 characters",
//     },
//     pattern: {
//       value: /^[A-Za-z0-9\s.,!?'"()\-@#&]+$/,
//       message: "Invalid characters in message",
//     },
//   })}
// />
//               {errors?.message && (
//                 <p className={styles.error}>{errors.message.message}</p>
//               )}
//             </div>
//             <Button
//               type="submit"
//               title={isPending ? "Sending..." : "Send"}
//               style={styles.submit__btn}
//               disabled={isPending}
//             />
//           </form>
//         </div>
//         <div className={styles.contact__info}>
//           <HeadingTitle text="Contact Us" style={styles.info__title} />
//           <SubHeadingTitle
//             subTitle=" We’d love to hear from you! Whether you have a question about your order, products, shipping, or returns, our support team is here to help ."
//             style={styles.info__desc}
//           />
//           <div className={styles.info__block}>
//             <FaAddressBook className={styles.info__icon} />
//             <div>
//               <h4>Address</h4>
//               <p>3rd Floor, OPP: HDFC Bank,
// Plot.No.-98, Venkateshwara Enclave,
// Suchitra 'X' Road,
// Hyderabad - 500067</p>
//             </div>
//           </div>
//           <div className={styles.info__block}>
//             <FaPhoneAlt className={styles.info__icon} />
//             <div>
//               <h4>Contact</h4>
//               <p>
//                 Phone:&nbsp;
//                 <a href="tel:+918886060799">+91 8886060799</a>
//               </p>
//               <p>
//                 WhatsApp:&nbsp;
//                 <a
//                   href="https://wa.me/918886060799"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   Chat on WhatsApp
//                 </a>
//               </p>
//             </div>
//           </div>
//           <div className={styles.info__block}>
//             <FaEnvelope className={styles.info__icon} />
//           <div>
//   <h4>Email</h4>
//   <p>
//     <a
//       href="https://mail.google.com/mail/?view=cm&fs=1&to=info@gdrbtechnologies.com"
//       target="_blank"
//       rel="noopener noreferrer"
//     >
//      info@gdrbtechnologies.com 
//     </a>
//   </p>
// </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };
// const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => (
//   <>
//     <BreadCrumb customPaths={[{ label: "Contact", path: newPath }]} />
//     <Banner heading={heading} imageUrl={imageUrl} />
//   </>
// );
// const MapLocation = () => {
//   return (
//     <div className={styles.map__wrapper}>
//        <iframe
//   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.1673527673083!2d78.47180607332092!3d17.499522899568685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9b2ba4ecf09b%3A0xd999abc2b0474a76!2sGDRB%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1776234280999!5m2!1sen!2sin"
//   width="800"
//   height="600"
//   style={{ border: 0 }}
//   allowFullScreen
//   loading="lazy"
//   referrerPolicy="no-referrer-when-downgrade"
// />
//       <BackToTop/>
//     </div>
//   );
// };
// export default Contact;


import { useLocation } from "react-router-dom";
import {
  BreadCrumb,
  Banner,
  HeadingTitle,
  Button,
  SubHeadingTitle,
  Input,
} from "../../../components/shared/index";
import styles from "./contact.module.css";
import { FaEnvelope, FaPhoneAlt, FaAddressBook } from "react-icons/fa";
import toast from "react-hot-toast";
import { useContactUsMutation } from "../../../queries/useContactUs";
import { useForm } from "react-hook-form";
import BackToTop from "../../../components/BackToTop/backtotop";
import { validateEmail, validateMessage, validateName, validateSubject } from "../../../utils/Validations";
const Contact = () => {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const newPath = parts[parts.length - 2];
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      subject: "",
      message: "",
    },
  });
  const { mutateAsync: contactSend, isPending } = useContactUsMutation();
  const handleMessageSend = async (data) => {
    try {
      const response = await contactSend(data);
      toast.success(response?.data?.message || "Message sent successfully");
      reset();
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Oops! Message send failed"
      );
    }
  };
  return (
    <section className={styles.contact__wrapper}>
       <BreadcrumbBanner
        newPath={newPath}
        heading="We’re here to help with your fashion questions, orders, and support"
        imageUrl="/contact.png"
    />
      <MapLocation />
      <div className={styles.contactDetails__wrapper}>
        <div className={styles.contact__form}>
          <HeadingTitle
            text="Tell Us Your Message"
            style={styles.contact__title}
          />
          <form onSubmit={handleSubmit(handleMessageSend)}>
            <div className={styles.form__group}>
              <label>
                Your Name <span>*</span>
              </label>
     <input
  type="text"
  placeholder="Enter your name"
  {...register("name", {
    validate: validateName,
  })}
/>
              {errors?.name && (
                <p className={styles.error}>{errors.name.message}</p>
              )}
            </div>
            <div className={styles.form__group}>
              <label>
                Your Email <span>*</span>
              </label>
       <input
  type="email"
  placeholder="Enter your email"
  {...register("email", {
    validate: validateEmail,
  })}
/>
              {errors?.email && (
                <p className={styles.error}>{errors.email.message}</p>
              )}
            </div>
            <div className={styles.form__group}>
              <label>Subject</label>
 <input
  type="text"
  placeholder="Enter subject"
  {...register("subject", {
    validate: validateSubject,
  })}
/>

{errors?.subject && (
  <p className={styles.error}>{errors.subject.message}</p>
)}
            </div>
            <div className={styles.form__group}>
              <label>
                Your Message <span>*</span>
              </label>
           <textarea
  rows="5"
  placeholder="Type your message"
  {...register("message", {
    validate: validateMessage,
  })}
/>

{errors?.message && (
  <p className={styles.error}>{errors.message.message}</p>
)}
            </div>
            <Button
              type="submit"
              title={isPending ? "Sending..." : "Send"}
              style={styles.submit__btn}
              disabled={isPending}
            />
          </form>
        </div>
        <div className={styles.contact__info}>
          <HeadingTitle text="Contact Us" style={styles.info__title} />
          <SubHeadingTitle
            subTitle=" We’d love to hear from you! Whether you have a question about your order, products, shipping, or returns, our support team is here to help ."
            style={styles.info__desc}
          />
          <div className={styles.info__block}>
            <FaAddressBook className={styles.info__icon} />
            <div>
              <h4>Address</h4>
              <p>3rd Floor, OPP: HDFC Bank,
Plot.No.-98, Venkateshwara Enclave,
Suchitra 'X' Road,
Hyderabad - 500067</p>
            </div>
          </div>
          <div className={styles.info__block}>
            <FaPhoneAlt className={styles.info__icon} />
            <div>
    <h4>Contact</h4>

    <p>
      Phone:&nbsp;
      <a
        href="tel:+918019070584"
        className={styles.phoneLink}
      >
        +91 8019070584
      </a>
    </p>

    <p>
      WhatsApp:&nbsp;
      <a
        href="https://wa.me/918019070584"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.whatsappLink}
      >
       Chat on whatsapp
      </a>
    </p>
  </div>
          </div>
          <div className={styles.info__block}>
            <FaEnvelope className={styles.info__icon} />
          <div>
  <h4>Email</h4>
  <p>
    <a
      href="https://mail.google.com/mail/?view=cm&fs=1&to=info@gdrbtechnologies.com"
      target="_blank"
      rel="noopener noreferrer"
    >
     info@gdrbtechnologies.com 
    </a>
  </p>
</div>
          </div>
        </div>
      </div>
    </section>
  );
};
const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => (
  <>
    <BreadCrumb customPaths={[{ label: "Contact", path: newPath }]} />
    <Banner heading={heading} imageUrl={imageUrl} />
  </>
);
const MapLocation = () => {
  return (
    <div className={styles.map__wrapper}>
       <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.1673527673083!2d78.47180607332092!3d17.499522899568685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9b2ba4ecf09b%3A0xd999abc2b0474a76!2sGDRB%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1776234280999!5m2!1sen!2sin"
  width="800"
  height="600"
  style={{ border: 0 }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>
      <BackToTop/>
    </div>
  );
};
export default Contact;